// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;

export const API_URL = {
    AUTH_URL: '/api/auth/login/',
    AUTH_TWO_FACTOR: '/api/auth/verify_opt/',
    SSO_CHECK: '/api/auth/saml/check/',
    SSO_HANDSHAKE: '/api/auth/saml/handshake/',
    USER_INFO: '/api/auth/user/',
    NOTIFY_LOGOUT: '/api/auth/notify_logout/',
    DEVICE_SEARCH: '/api/management/device_search',
    GENERAL_SETTINGS: '/api/settings/general_settings/',
    MANAGEMENT_ORGANIZATION_DATA: '/api/management/organizations/',
    MANAGING_ORGANIZATION: '/api/management/manage_organization/',
    MANAGEMENT_SCRIPTS: '/api/management/scripts/',
    MANAGEMENT_POLICY: '/api/management/policy/',
    MANAGEMENT_GROUPS: '/api/management/groups/',
    MANAGEMENT_ADHOC: '/api/management/adhoc/',
    MANAGEMENT_VIEWS: '/api/management/views/',
    RULE_STATEMENT_DATA: '/api/automation/rule_statements_data',
    RULE_STATEMENT_VALUE: '/api/automation/rule_statement_values/',
    ASSET_INVENTORY: '/api/reports/asset_inventory/',
    ASSET_INVENTORY_COLUMNS: '/api/reports/asset_inventory/columns',
    ASSET_VIEWS: '/api/reports/asset_views/',
    REPORT_GENERATE_TASK: '/api/reports/generate_task',
    REPORT_TASK_STATUS: '/api/reports/task_status',
    REPORT_GET: '/api/reports/get'
};
